/**
 * Código estruturado dos erros de validação de fórmulas devolvidos em `erros[]`.
 * Espelha o FormulaErrorCodeEnum do MotorFiscal e do Suprimentos (mesmos valores).
 */
export enum FormulaErrorCodeEnum {
    FormulaInvalida = 1,
    ReferenciaCircular = 2,
    FormulaNaoAplicavel = 3,
    FormulaNaoPersonalizavel = 4,
    ModeloNaoPertenceFormula = 5,
    CicloAmbiguo = 6,
    CicloPontosDecisaoInvalidos = 7,
    CicloAlterado = 8,
}
